const actions = {
  SET_STATE: 'singleaccounts/SET_STATE',
  LOAD_ALL: 'singleaccounts/LOAD_ALL',
  LOAD_SINGLE_ACCOUNTS: 'singleaccounts/LOAD_SINGLE_ACCOUNTS',
  GETACCOUNTSNOTES: 'singleaccounts/GETACCOUNTSNOTES',
  LOAD_LEDGER: 'singleaccounts/LOAD_LEDGER',
}

export default actions
